/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnvironmentToxinsResponseDto
 */
export interface EnvironmentToxinsResponseDto {
    /**
     * Unique identifier for the patient's environment toxins record.
     * @type {string}
     * @memberof EnvironmentToxinsResponseDto
     */
    id: string;
    /**
     * Patient identity
     * @type {string}
     * @memberof EnvironmentToxinsResponseDto
     */
    patientId: string;
    /**
     * Type of home environment.
     * @type {string}
     * @memberof EnvironmentToxinsResponseDto
     */
    home: EnvironmentToxinsResponseDtoHomeEnum;
    /**
     * Details about other home type (required if home is 'Other').
     * @type {string}
     * @memberof EnvironmentToxinsResponseDto
     */
    homeOther?: string;
    /**
     * Indicates if the patient has air/water filters in their home.
     * @type {boolean}
     * @memberof EnvironmentToxinsResponseDto
     */
    airWaterFilters: boolean;
    /**
     * Indicates if the patient has chemical exposure (e.g., workplace chemicals, pesticides).
     * @type {Array<string>}
     * @memberof EnvironmentToxinsResponseDto
     */
    chemicalExposure?: Array<string>;
    /**
     * Other chemical exposure information.
     * @type {string}
     * @memberof EnvironmentToxinsResponseDto
     */
    chemicalOther?: string;
    /**
     * Additional information about environmental toxins exposure.
     * @type {string}
     * @memberof EnvironmentToxinsResponseDto
     */
    additionalInformation?: string;
    /**
     * Last updated timestamp
     * @type {string}
     * @memberof EnvironmentToxinsResponseDto
     */
    lastUpdated: string;
}


/**
 * @export
 */
export const EnvironmentToxinsResponseDtoHomeEnum = {
    House: 'House',
    Townhouse: 'Townhouse',
    Apartment: 'Apartment',
    Other: 'Other'
} as const;
export type EnvironmentToxinsResponseDtoHomeEnum = typeof EnvironmentToxinsResponseDtoHomeEnum[keyof typeof EnvironmentToxinsResponseDtoHomeEnum];


/**
 * Check if a given object implements the EnvironmentToxinsResponseDto interface.
 */
export function instanceOfEnvironmentToxinsResponseDto(value: object): value is EnvironmentToxinsResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('home' in value) || value['home'] === undefined) return false;
    if (!('airWaterFilters' in value) || value['airWaterFilters'] === undefined) return false;
    if (!('lastUpdated' in value) || value['lastUpdated'] === undefined) return false;
    return true;
}

export function EnvironmentToxinsResponseDtoFromJSON(json: any): EnvironmentToxinsResponseDto {
    return EnvironmentToxinsResponseDtoFromJSONTyped(json, false);
}

export function EnvironmentToxinsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnvironmentToxinsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'home': json['home'],
        'homeOther': json['homeOther'] == null ? undefined : json['homeOther'],
        'airWaterFilters': json['airWaterFilters'],
        'chemicalExposure': json['chemicalExposure'] == null ? undefined : json['chemicalExposure'],
        'chemicalOther': json['chemicalOther'] == null ? undefined : json['chemicalOther'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : json['additionalInformation'],
        'lastUpdated': json['lastUpdated'],
    };
}

export function EnvironmentToxinsResponseDtoToJSON(json: any): EnvironmentToxinsResponseDto {
    return EnvironmentToxinsResponseDtoToJSONTyped(json, false);
}

export function EnvironmentToxinsResponseDtoToJSONTyped(value?: EnvironmentToxinsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'home': value['home'],
        'homeOther': value['homeOther'],
        'airWaterFilters': value['airWaterFilters'],
        'chemicalExposure': value['chemicalExposure'],
        'chemicalOther': value['chemicalOther'],
        'additionalInformation': value['additionalInformation'],
        'lastUpdated': value['lastUpdated'],
    };
}

